import { ModelPerfPredict } from '../../utils/ModelPerfPredict';

export class FollowOnModelTotalDTO {
  currentCost = 0;
  currentCompValue = 0;
  rounds: FollowOnRoundTotalDTO[] = [];
  perfPredict: ModelPerfPredict = new ModelPerfPredict();
}

export class FollowOnRoundTotalDTO {
  cost = 0;
  totalRound = 0;
}
